import { Component, OnInit, Inject } from '@angular/core';

import { MatSnackBar, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NestService } from '../../services/nest.service';

@Component({
  selector: 'app-emergencycontact',
  templateUrl: './emergencycontact.component.html',
  styleUrls: ['./emergencycontact.component.css']
})
export class EmergencycontactComponent implements OnInit {
  action: any;
  msg: any;
  alternatecontact: any;
  vetname: any;
  vetcontact: any ;
  data = [];
  constructor(private nestService: NestService, public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data1,
 public dialogRef: MatDialogRef<EmergencycontactComponent>) { }

  ngOnInit() {
  }

  done() {
    if (this.alternatecontact !== undefined || this.vetname !== undefined || this.vetcontact !== undefined
     || this.alternatecontact !== null || this.vetname !== '' || this.vetcontact !== null) {
      this.data.push({'alternatecontact': this.alternatecontact, 'vetname': this.vetname, 'vetcontact': this.vetcontact})
      this.dialogRef.close(this.data);
    } else {
      this.dialogRef.close();
    }
  
  }

  showAlert() {
    this.snackBar.open(this.msg, this.action , {
      duration: 4000,
    });
 }

 cancel() {
  this.dialogRef.close();
 }
}
